import { useEffect, useState } from "react";
import { fetchBlob } from "../api/client";

export function WalletAddQr({ passportId, show }: { passportId: number; show: boolean }) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!show) {
      setSrc(null);
      return;
    }
    let objectUrl: string | null = null;
    let cancelled = false;
    fetchBlob(`/api/portal/passports/${passportId}/wallet-qr`)
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob);
        if (!cancelled) setSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setSrc(null);
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [passportId, show]);

  if (!src) return null;
  return (
    <div className="wallet-add">
      <h4 className="field-label">Scan to add to Apple Wallet</h4>
      <p className="muted">Add to Google Wallet</p>
      <img className="wallet-qr" src={src} alt="Scan to add to Apple Wallet. Add to Google Wallet" />
    </div>
  );
}
